import { SxProps, Theme } from '@mui/material';

export const storeLocatorSateDropdownLinkSX: SxProps<Theme> = (theme) => ({
	color: theme.palette.secondary.main,
	fontSize: '15px',
	'&:hover': {
		cursor: 'pointer',
		textDecoration: 'underline',
		svg: {
			textDecoration: 'none',
		},
	},
});
